import { Typography } from './Typography';
import styles from './SectionHeading.module.css';
export function SectionHeading({
  eyebrow,
  title,
  description,
  align = 'center',
}: {
  eyebrow: string;
  title: string;
  description?: string;
  align?: 'center' | 'start';
}) {
  return (
    <div className={`${styles.heading} ${styles[align]}`}>
      <Typography variant="eyebrow" tone="muted">
        {eyebrow}
      </Typography>
      <Typography as="h2" variant="heading">
        {title}
      </Typography>
      {description && <Typography tone="muted">{description}</Typography>}
    </div>
  );
}
